import { useStoreNames } from 'utils/useStorePath';
import getStoreContent from 'utils/content';

export const useContent = () => {
  const { storeName } = useStoreNames();
  const contentData = getStoreContent(storeName);
  return contentData;
};
